module.exports = __webpack_public_path__ + "app/kiss-order/detail/order-detail-history-2kNJf5ST.html";